import { ChatHeader } from "../types/chat-header";

export const chatHeaderFallback: ChatHeader = {
  styles: {
    position: 'relative',

    display: 'flex',
    gap: '7px',
    alignItems: 'center',
    justifyContent: 'space-between',

    padding: '15px 20px',
    borderTopLeftRadius: '10px',
    borderTopRightRadius: '10px',
    background: '#710754'
  },
  title: {
    styles: {
      fontSize: '16px',
      fontFamily: 'Poppins, sans-serif',
      color: 'white',
      display: 'flex',
      gap: '7px',
      alignItems: 'center',
    },
    text: 'TitleSmaple'
  },
  icon: {
    styles: {
      // position: 'absolute',
      width: '20px',
      height: '20px'
    },
    // src: '/assets/ai-icon.svg'
  },
  inversion: false
};